import { createContext, useContext } from 'react'

import { IFeatureFlags } from '$/types'

export const FeatureFlagsContext = createContext<{ flags: IFeatureFlags }>({
  flags: {}
})

export function useFeatureFlags() {
  return useContext(FeatureFlagsContext)
}

export function useFeatureFlag(val: string, defaultValue = false): boolean {
  const { flags } = useContext(FeatureFlagsContext)

  return flags[val] ?? defaultValue
}
